import styled from 'styled-components';

const StyledStickyBoard = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export default StyledStickyBoard;